import styled, { css } from 'styled-components';

import { cssBreakpoints, shadows } from 'theme/theme';

export const DropdownListMenuHolder = styled.div`
  position: absolute;
  z-index: 2000;
  box-shadow: ${shadows.highest};
  background-color: white;
  border-radius: 4px;
  right: 0;
  margin-top: 4px;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const DropdownListMenuList = styled.div<{
  $width?: number;
  $height?: string;
}>`
  max-width: 270px;
  min-width: 200px;
  overflow-x: hidden;

  ${(props) =>
    props.$width &&
    css`
      min-width: ${props.$width}px;
    `}
  ${(props) =>
    props.$height &&
    css`
      max-height: ${props.$height};
      overflow-y: scroll;
    `}
`;
